<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="1" epub:type="epigraph" id="epigraph">
<h1 class="hidden" data-number="1" epub:type="epigraph">Epigraph</h1>
<blockquote>
<p class="no_header"><em>‘The seed of the cedar will become cedar; the seed of the bramble can only become bramble.’</em></p>
</blockquote>
<p class="right_align_para">Saint-Exupéry</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c5d9e824